import { createContext, useState } from "react";

export const UsersStatusContext = createContext();

export const UsersStatusContextProvider = ({ children }) => {
  const [usersStatus, setUsersStatus] = useState(null);
  return (
    <UsersStatusContext.Provider value={{ usersStatus, setUsersStatus }}>
      {children}
    </UsersStatusContext.Provider>
  );
};
